import React from 'react';
import { Reveal, Stagger, StaggerItem, CountUp } from './LandingMotion';
import { IntelligentBackdrop } from './IntelligentBackdrop';

// Truthful scale numbers (from the product: ~40 Bolt server tools, 214 trade-calc
// screens across 5 trades).
const STATS = [
  { val: '40+', label: 'AI skills Bolt can run on your jobsite' },
  { val: '214', label: 'built-in trade calculators' },
  { val: '5', label: 'trades, deeply covered' },
];

const VALUE_CLASS =
  'vh-nums text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter mb-3 text-transparent bg-clip-text bg-gradient-to-br from-[#1C1C1E] to-slate-500';

// Numeric stats animate 0 → value on scroll-in via CountUp; any non-numeric value
// renders as plain text. The gradient/value classes live on the block <div> either
// way so layout (block, mb-3, bg-clip-text gradient) is unchanged.
const renderStatValue = (val) => {
  switch (val) {
    case '40+':
      return <div className={VALUE_CLASS}><CountUp value={40} suffix="+" /></div>;
    case '214':
      return <div className={VALUE_CLASS}><CountUp value={214} /></div>;
    case '5':
      return <div className={VALUE_CLASS}><CountUp value={5} /></div>;
    default:
      return <div className={VALUE_CLASS}>{val}</div>;
  }
};

export const StatsSection = () => {
  return (
    <section className="relative overflow-hidden py-24 md:py-28 bg-white border-y border-black/[0.06]">
      <IntelligentBackdrop />
      <div className="relative z-10 max-w-[1200px] mx-auto px-6 text-center">
        <Reveal>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1C1C1E] tracking-tight mb-4">
            Depth where the work happens
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto mb-16 text-lg font-light">
            From the first calculation to the last close-out — Bolt is backed by a deep, purpose-built foundation, not a thin chatbot.
          </p>
        </Reveal>

        <Stagger className="grid grid-cols-1 sm:grid-cols-3 gap-y-12 gap-x-8 max-w-3xl mx-auto">
          {STATS.map((s) => (
            <StaggerItem key={s.label}>
              {renderStatValue(s.val)}
              <div className="text-sm text-slate-600 leading-relaxed max-w-[200px] mx-auto">{s.label}</div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
